// Landing page
import React from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MeaButton from '../../components/MeaButton';
import { AuthStatus, useAuthContext } from '../../hooks/useAuthContext';
import { Divider } from 'primereact/divider';
import RequestAccess from '../family/components/RequestAccess';
import './LandingPage.css';


const APP_VERSION = process.env.REACT_APP_VERSION;
const GIT_COMMIT = process.env.REACT_APP_GIT_COMMIT;
const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

const LandingPage = () => {
    const navigate = useNavigate();
    const { account, logout, status } = useAuthContext();

    useEffect(() => {
        if (status === AuthStatus.AUTHENTICATED) {
            navigate("/school", { replace: true });
        }
    }, [navigate, status]);

    return (
        <div className="landing-page h-screen flex flex-column">
            {/* Navbar */}
            <div className="landing-navbar py-3 px-6 flex align-items-center justify-content-between">
                <img src="/images/mealogo.png" alt="MEA" height={50} />
                <div className="flex gap-2">
                    {account && (
                        <>
                            <MeaButton label="Mes écoles" className="font-bold" onClick={() => navigate("/user/schools")} />
                            <MeaButton label="Déconnexion" icon="pi pi-sign-out" className="p-button-text font-bold" onClick={() => logout()} />
                        </>
                    )}
                </div>
            </div>

            {/* Main content — left: description, right: form card */}
            <div className="flex flex-grow-1 align-items-center lg:align-items-start p-4 gap-2 flex-column lg:flex-row justify-content-start landing-content-wrapper">
                {/* Left: presentation text */}
                <div className="landing-intro-section lg:align-items-start lg:text-left">
                    <div className="landing-intro-title">Mon École Arabe</div>
                    <div className="landing-intro-subtitle" style={{ color: 'var(--landing-accent)' }}>
                        Votre partenaire pour une éducation réussie
                    </div>
                    <p className="landing-intro-description">
                        Une gestion de l'école digitalisée pour une administration plus efficace, des parents mieux informés et plus investis, et des élèves qui réussissent.
                    </p>
                    {account && (
                        <div className="landing-action-buttons lg:justify-content-start">
                            <MeaButton label="Mes écoles" icon="pi pi-home" onClick={() => navigate("/user/schools")} />
                            <MeaButton label="Déconnexion" icon="pi pi-sign-out" severity="secondary" text onClick={() => logout()} />
                        </div>
                    )}
                </div>

                {/* Right: form card */}
                {!account && (
                    <div className="landing-card">
                        <div className="landing-card-surface">
                            <RequestAccess embedded />
                        </div>
                        <div className="px-4 pb-3">
                            <Divider align="center" className="landing-divider">
                                <span className="text-500 text-sm font-bold">ou</span>
                            </Divider>
                        </div>
                        <div className="px-4 pb-4">
                            <MeaButton
                                label="Connexion du personnel"
                                icon="pi pi-lock"
                                severity="secondary"
                                outlined
                                className="w-full"
                                style={{ height: "50px" }}
                                onClick={() => navigate("/auth/login")}
                            />
                        </div>
                    </div>
                )}
            </div>

            {/* Footer */}
            <div className="px-3 pb-2">
                <span className="text-xs text-500">{APP_VERSION} ({GIT_COMMIT} - {ENVIRONMENT})</span>
            </div>
        </div>
    );
};

export default LandingPage;
